import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';
import Grid from '@material-ui/core/Grid';
import LoginForm from './forms/LoginFormPres';
import SSOLogin from './SSOLoginPres';
import LoginError from './forms/LoginErrorPres';
import { FPASSPAGE } from 'src/ui/features/Login/state/constants';
import { LOGOUT_URL } from 'src/constants/constants.js';
import { clearPresistfromLocalStorge, enablePresist, clearCookieFromBrowserStorage } from 'src/helpers';

export const validateMail = email => {
  var re = /^(([^<>()[\]\\.,;:\s@|]+(\.[^<>()[\]\\.,;:\s@|]+)*)|(|.+|))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

class Login extends Component {
  state = {
    loginemail: '',
    loginpassword: '',
    blankPassword: false,
    blankEmail: false,
    error: false,
  };

    componentDidMount() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('isSessionActive');
    sessionStorage.removeItem('userInfo');
    sessionStorage.removeItem('consentList');
    localStorage.clear();
    sessionStorage.clear();
    clearCookieFromBrowserStorage();
    clearPresistfromLocalStorge();
    if (window.location.href.includes(LOGOUT_URL)) {
      sessionStorage.clear();
      this.props.logoutSession();
      localStorage.clear(); 
      clearPresistfromLocalStorge();
    }
  }

  onLoginClick = evt => {
    enablePresist();
    evt.preventDefault();
    const { loginemail, loginpassword } = this.state;
    const emailIsValid = validateMail(loginemail);
    this.setState({
      blankEmail: !emailIsValid,
      blankPassword: loginpassword === '',
      error: !emailIsValid || loginpassword === '',
    });
    if (emailIsValid && loginpassword !== '') return this.props.onClick(false, loginemail, loginpassword);
  };

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  render() {
    const { error, loginStatus, numberAttempts, isUserLocked, location } = this.props;
    let {pathname} = location;
    return (
      <Fragment>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <div className="title">{intl.get('login.title')}</div>
        </Grid>
        {isUserLocked || (error && error.message) ? (
          <LoginError isUserLocked={isUserLocked} numberAttempts={numberAttempts} error={error} maxAttempts={'third attempt'} />
        ) : null}
        {pathname === '/authlogin' ? <Fragment>
        <LoginForm
          hasError={this.state.error || (error && error.message !== '')}
          onChange={this.handleChange}
          isUserLocked={isUserLocked}
          actionButton={this.onLoginClick.bind(this)}
          loginStatus={loginStatus}
          blankEmail={this.state.blankEmail}
          blankPassword={this.state.blankPassword}
        />
        <Grid item xs={12} lg={12}>
          <a className="link" onClick={evt => this.props.gotoPage(FPASSPAGE)}>
            {intl.get('login.forgotmypassword')}
          </a>
          <Link to={'#'} className="link spacer">
            {intl.get('login.registernewuser')}
          </Link>
        </Grid>
        </Fragment> :
        <SSOLogin {...this.props} />
        }
      </Fragment>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/ui/features/Login/presentational/LoginPres.js